export default __webpack_public_path__ + "static/media/vjcet3.89bca12a.jpg";